import type { CityConfig } from "../city-template/types";

export const milfordDeConfig: CityConfig = {
  city: "Milford",
  state: "Delaware",
  stateAbbr: "DE",
  slug: "milford-de",
  route: "/milford-de",
  title: "Emergency Passport Milford DE | Expedited Passport Kent & Sussex County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Milford, DE — as fast as 24 hours. Fast passport renewal for Kent and Sussex County residents at the Delaware county border. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Milford, DE",
  heroSubtitle: "Located at the crossroads of Kent and Sussex Counties and need a passport fast? Fast Passport Center helps Milford, Harrington, Felton, and southern Delaware residents get their expedited passports as quickly as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Milford%20Delaware%20historic%20downtown%20district%20with%20Mispillion%20River%20waterfront%2C%20charming%20brick%20buildings%2C%20small-town%20American%20architecture%2C%20Delaware%20countryside%20with%20green%20trees%20and%20clear%20sky%2C%20warm%20afternoon%20sunlight%2C%20peaceful%20community%20atmosphere%2C%20no%20visible%20text%20or%20people%2C%20photorealistic%20landscape%20photography%20style&width=1800&height=700&seq=milford-de-hero-001&orientation=landscape",
  heroImageAlt: "Historic downtown Milford Delaware along the Mispillion River waterfront",
  geoPosition: "38.9126;-75.4280",
  geoPlacename: "Milford, Delaware",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Philadelphia Passport Agency",
    address: "600 Arch St Suite 4200, Philadelphia, PA 19106",
    distance: "Approximately 90–100 minutes from Milford, DE via DE Route 1 and I-95 N",
  },
  nearbyCitiesZips: [
    { name: "Milford", zips: "19963" },
    { name: "Harrington", zips: "19952" },
    { name: "Felton", zips: "19943" },
    { name: "Lincoln", zips: "19960" },
    { name: "Frederica", zips: "19946" },
    { name: "Houston", zips: "19954" },
    { name: "Ellendale", zips: "19941" },
    { name: "Greenwood", zips: "19950" },
    { name: "Bridgeville", zips: "19933" },
    { name: "Seaford", zips: "19973" },
    { name: "Dover", zips: "19901, 19902, 19904" },
    { name: "Smyrna", zips: "19977" },
    { name: "Georgetown", zips: "19947" },
    { name: "Lewes", zips: "19958" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Milford and southern Delaware departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-home-5-line", title: "Kent & Sussex County", desc: "Serving Milford, Harrington, Felton, and the southern Delaware border region" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to Philadelphia" },
  ],
  internalLinks: [
    { name: "Expedited passport in Dover, DE", route: "/dover-de" },
    { name: "Emergency passport help in Seaford, DE", route: "/seaford-de" },
    { name: "Urgent passport services in Georgetown, DE", route: "/georgetown-de" },
    { name: "Delaware passport services overview", route: "/delaware" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Milford, Delaware remotely via secure registered courier. We do not have a walk-in office in Milford — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Milford and southern Delaware travelers without the long drive to Philadelphia.",
  fpcOfficeAddress: "1700 Market St, Suite 1005, Philadelphia, PA 19103",
  fpcOfficeDistance: "Serving Milford, Harrington, Felton, and southern Kent and Sussex Counties",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Milford, Delaware area and the Kent-Sussex County border region. From the historic Mispillion River waterfront to the rural communities of Felton and Harrington, from Lincoln to Frederica — we serve all of southern Delaware's diverse residential communities.",
  nearbyCitiesIntro: "We serve Milford and nearby communities including Harrington, Felton, Lincoln, Frederica, Houston, Ellendale, Greenwood, and Bridgeville. We also serve residents in Seaford, Georgetown, Dover, and Smyrna who prefer our expedited service over the self-service route.",
  howItWorksIntro: "Most Milford travelers complete everything online and ship documents overnight. No need to drive 90–100 minutes to Philadelphia or take time off from work.",
  mistakesIntro: "Milford, Delaware sits at the crossroads of two counties with a mix of historic downtown residents and rural families. Here are the most common passport mistakes we see from Milford travelers.",
  testimonialsIntro: "Milford, Delaware travelers — from rural families to waterfront residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Milford, DE? Here are the most common ones we hear from southern Delaware travelers.",
  statePageRoute: "/states/delaware",
  statePageName: "Delaware",
  dmvWebsite: "https://www.dmv.de.gov",
  dmvLabel: "Delaware DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified Delaware birth and death certificates from the Delaware Division of Public Health — online, by mail, or in person at the Dover office.", url: "https://dhss.delaware.gov/dhss/dph/ss/vitalstats.html" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Kent County Clerk of the Peace in Dover. Required for name change passport applications.", url: "https://www.co.kent.de.us/" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Kent County Prothonotary. Required for name change passport corrections.", url: "https://www.co.kent.de.us/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Delaware, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 90–100 min to Philadelphia", "Full day commitment — challenging for families"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for family travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Milford travelers with immediate departure needs — as fast as 24 hours. Perfect for last-minute family trips and southern Delaware business travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Milford adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Milford address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Milford residents and families — including first international trips.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Milford and southern Delaware residents.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Milford families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Milford Delaware residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Milford DE", description: "Urgent passport processing for Milford Delaware travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Milford DE", description: "Fast passport renewal for Milford Delaware residents with a previously-issued passport." },
    { name: "First-Time Passport Milford DE", description: "New passport application services for Milford Delaware residents applying for their first passport." },
    { name: "Child Passport Milford DE", description: "Minor passport services for Milford Delaware families with children under 16." },
  ],
  testimonials: [
    {
      name: "Patricia M.",
      location: "Milford, DE",
      rating: 5,
      text: "Our family cruise to the Bahamas was in two weeks and our daughter's passport had expired. Fast Passport Center had her new passport in 4 days. Incredible service for a small town like Milford.",
      service: "Child Passport",
    },
    {
      name: "James R.",
      location: "Harrington, DE",
      rating: 5,
      text: "Emergency business trip to Toronto. I called on Monday and had my renewed passport by Thursday. No way I could have driven to Philadelphia and back with my work schedule.",
      service: "Passport Renewal",
    },
    {
      name: "Linda K.",
      location: "Felton, DE",
      rating: 5,
      text: "Lost my passport before a mission trip to Guatemala. I live in rural Felton and had no idea where to start. Fast Passport Center guided me through everything and saved my trip.",
      service: "Lost Passport",
    },
    {
      name: "Michael T.",
      location: "Lincoln, DE",
      rating: 5,
      text: "First-time passport for my wife and me. We are in our 60s and never traveled internationally. Fast Passport Center made the whole process simple and stress-free from our home in Lincoln.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "milford-de-1",
      name: "Milford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 NE Front St",
      city: "Milford",
      state: "DE",
      zip: "19963",
      phone: "(302) 422-6311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Milford, near the Mispillion River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Milford and southern Kent County. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-de-2",
      name: "Harrington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 Commerce St",
      city: "Harrington",
      state: "DE",
      zip: "19952",
      phone: "(302) 398-3691",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 12 miles north of Milford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for northern Milford and Harrington area residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-de-3",
      name: "Seaford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2001 Bridgeville Hwy",
      city: "Seaford",
      state: "DE",
      zip: "19973",
      phone: "(302) 629-4591",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 15 miles west of Milford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for western Milford and Sussex County residents closer to the Seaford area.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-de-4",
      name: "Dover Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "550 S Bay Rd",
      city: "Dover",
      state: "DE",
      zip: "19901",
      phone: "(302) 734-9103",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 25 miles north of Milford in the state capital",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment availability for Milford residents willing to travel north.",
      icon: "ri-mail-line",
    },
    {
      id: "milford-de-5",
      name: "Georgetown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 N Race St",
      city: "Georgetown",
      state: "DE",
      zip: "19947",
      phone: "(302) 855-1231",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 18 miles south of Milford in Sussex County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Sussex County residents south of Milford. Call ahead to confirm passport service hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited Philadelphia slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 90–100 min drive to Philadelphia", fpc: "No — ship from Milford" },
    { feature: "Family Travel Support", agency: "No flexibility for group needs", fpc: "Yes — we handle multi-passport cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Milford's rural families often discover their passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Milford and southern Delaware acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Knowing the Closest Acceptance Facility",
      description: "With Milford's location at the Kent-Sussex border, many residents are unsure which post office is closest. The Milford Post Office at 301 NE Front St is your primary local option.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Milford residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Milford or Harrington." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location near Milford or Felton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Milford address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Milford, DE?", a: "Fast Passport Center offers emergency passport processing in Milford, Delaware in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Philadelphia Passport Agency (90–100 minutes from Milford) — without you needing to make the drive." },
    { q: "Does Milford, Delaware have its own passport agency?", a: "No — neither Milford nor the state of Delaware has a regional passport agency. The closest facility is the Philadelphia Passport Agency, approximately 90–100 minutes from Milford via DE Route 1 and I-95. Fast Passport Center's courier service means Milford residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Harrington or Felton?", a: "Absolutely. Fast Passport Center serves all of southern Delaware including Harrington, Felton, Lincoln, Frederica, and the rural communities along the Kent-Sussex border. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Milford, DE?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Milford, Delaware travelers use?", a: "Most Milford residents fly internationally through Philadelphia International Airport (PHL), approximately 90–100 minutes north via DE Route 1 and I-95. Wilmington Airport (ILG) in New Castle offers limited domestic connections. Baltimore-Washington International (BWI) is an alternative for some travelers. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Milford?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Milford, Harrington, and Felton. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Milford?", a: "The Milford Post Office at 301 NE Front St is the primary local acceptance facility. The Harrington Post Office at 2 Commerce St is nearby for northern residents. The Dover Post Office at 550 S Bay Rd is a larger option 25 miles north. All require appointments." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Milford residents should plan ahead, especially for family trips and seasonal travel." },
  ],
  photoLocations: [
    { name: "Walgreens — Milford", address: "1005 N Dupont Blvd, Milford, DE 19963", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Milford", address: "699 N Dupont Blvd, Milford, DE 19963", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Milford", address: "936 N Dupont Blvd, Milford, DE 19963", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Milford", address: "631 N Dupont Blvd, Milford, DE 19963", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    { name: "DMV — Milford", address: "2009 N Dupont Blvd, Milford, DE 19963", hours: "Mon–Fri: 8AM–4:30PM", note: "Serves Milford and southern Kent County. Appointments recommended.", featured: true },
    { name: "DMV — Dover", address: "3030 S Dupont Hwy, Dover, DE 19901", hours: "Mon–Fri: 8AM–4:30PM", note: "Alternative for northern residents. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "PHL",
      name: "Philadelphia International Airport",
      distance: "90–100 miles from Milford, DE",
      address: "8000 Essington Ave, Philadelphia, PA 19153",
      note: "Primary international departure airport for Milford travelers. 90–100 minute drive north on DE Route 1 and I-95. Major international hub with direct flights to Europe, the Caribbean, and beyond.",
      flightUrl: "https://www.phl.org/",
      flightLabel: "PHL Flight Info",
      featured: true,
    },
    {
      code: "ILG",
      name: "Wilmington Airport (New Castle)",
      distance: "50 miles from Milford, DE",
      address: "141 N DuPont Hwy, New Castle, DE 19720",
      note: "Closest airport to Milford with limited domestic service. No major international connections.",
      flightUrl: "https://www.flyilg.com/",
      flightLabel: "ILG Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International",
      distance: "80 miles from Milford, DE",
      address: "7062 Elm Rd, Baltimore, MD 21240",
      note: "Alternative option for budget airlines and travelers with flexible routing.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};